/* global axios */
import ApiClient from './ApiClient';

class TimelineAPI extends ApiClient {
  constructor() {
    super('timelines', { accountScoped: true });
  }

  get(subjectType, subjectId) {
    return axios.get(this.url, {
      params: { subject_type: subjectType, subject_id: subjectId },
    });
  }
}

export default new TimelineAPI();
